import React, { useState } from "react";
import DeleteConfirm from "../../components/Dialogs/DeleteConfirm";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import actionCreator from "../../redux/action/actionCreator";
import Toast from "../../components/MessageToast";

const BlogContainer = (props) => {
  const { isOpen, isFor, handleCloseModel, itemId, store, action } = props;
  const dispatch = useDispatch();

  const [state, setState] = useState({
    openToast: false,
  });
  const handleDeleteConfirm = async () => {
    await toast.promise(
      dispatch(
        actionCreator({
          method: "DELETE",
          path: `/api/${isFor.toLowerCase()}/${itemId}`,
          actionType: action,
        })
      ),
      {
        pending: `Deleting ${isFor.slice(0, -1)}`,
      }
    );
    handleCloseModel(false);
    setState({ ...state, openToast: true });
  };

  const navigate = useNavigate();

  if (store.message && state.openToast) {
    Toast({
      message: store.message,
      type: store.message.includes("successful") ? "success" : "error",
      onClose: () =>
        store.message.includes("successful") ? navigate(-1) : null,
    });

    setState({ ...state, openToast: false });
  }

  return (
    <DeleteConfirm
      open={isOpen}
      dialogMessage={`Do you want to Delete this ${isFor.slice(
        0,
        -1
      )}, Kindly note that this action is irreversible`}
      onCancel={() => handleCloseModel(false)}
      onConfirm={handleDeleteConfirm}
    />
  );
};

export default BlogContainer;
